import React from 'react'
import { Navigate } from 'react-router'
import { PathNames } from 'constants/General'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { AccountCapabilities } from 'types/capabilities/capabilities'

const CapabilityProtectedComponent = ({
  children,
  capabilityCheck,
}: {
  children: React.ReactElement
  capabilityCheck: (accountCapabilities: AccountCapabilities) => boolean
}) => {
  const { accountCapabilities } = useAccountsContext()

  return capabilityCheck(accountCapabilities) ? children : <Navigate to={PathNames.NOT_FOUND} />
}

export default CapabilityProtectedComponent
